module.exports = __webpack_public_path__ + "img/cooperationAdvantagesImg2.7acfe293.png";